/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForTenableNessus extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForTenableNessus");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForTenableNessus.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForTenableNessus>): ServiceAccountNativeDetailsForTenableNessus {
        let obj = Object.assign(new ServiceAccountNativeDetailsForTenableNessus(), model);
        ServiceAccountNativeDetailsForTenableNessus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForTenableNessus>): ServiceAccountNativeDetailsForTenableNessus {
        if (!model) return null;
        return ServiceAccountNativeDetailsForTenableNessus.newInstance(<ServiceAccountNativeDetailsForTenableNessus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForTenableNessus) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForTenableNessus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForTenableNessus): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForTenableNessus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
